module.exports = __webpack_public_path__ + "static/img/002.8d5f7761.png";